"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useDelayedClose_1 = __importDefault(require("./useDelayedClose"));
const useModalState = (shouldUseDelayedClose) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const isClosed = (0, useDelayedClose_1.default)(isOpen, !shouldUseDelayedClose);
    const closeModal = (0, react_1.useCallback)(() => {
        setIsOpen(false);
    }, []);
    const openModal = (0, react_1.useCallback)(() => {
        setIsOpen(true);
    }, []);
    return { closeModal, openModal, isOpen, ...shouldUseDelayedClose && { isClosed } };
};
exports.default = useModalState;
//# sourceMappingURL=useModalState.js.map